module.exports = __webpack_public_path__ + "img/favorite-remove.64bd4344.svg";